module.exports = __webpack_public_path__ + "static/media/bag-icon.659219a9.svg";